<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 30 26"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.7224 0L29.4449 25.5H0L14.7224 0Z" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.4346 16.6508L24.8736 22.6363H4.57129L6.56099 19.1756H8.01028L6.74522 21.3801H22.6997L20.71 17.907H19.2588C19.6814 18.6414 20.1037 19.3761 20.5254 20.1114H19.0761L17.8111 17.907H11.6331L10.3681 20.1114H8.9188C9.3405 19.3761 9.7628 18.6414 10.1855 17.907H7.28564L14.7286 5L20.71 15.3946H19.2607L14.7286 7.51243L9.45957 16.6508H10.9093C11.6606 15.3477 12.4131 14.0452 13.1661 12.7418C13.6866 11.8408 14.2074 10.9394 14.7282 10.037C15.6924 11.7182 16.6596 13.3963 17.6269 15.0743C17.9298 15.5998 18.2326 16.1253 18.5354 16.6508H21.4346ZM12.3578 16.6506H17.0864L14.7282 12.5495L12.3578 16.6506Z"
      fill="white"
    />
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 18 },
    height: { type: [Number, String], default: 20 },
    color: { type: String, default: colors.iconArinet },
  },
};
</script>
